<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.documentDetails") }}</h4>
    </div>
    <div class="brick_box">
      <table class="mgt_tbl mgb_0">
        <tbody>
          <tr>
            <th>{{ $t("product.docTitle") }}</th>
            <td>
              <input
                type="text"
                v-model="form.docTitle"
                class="int_type01 mgt_seltype"
                style="width: 99.8%"
                name="docTitle"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("product.docDesc") }}</th>
            <td>
              <input
                type="text"
                v-model="form.docDesc"
                class="int_type01 mgt_seltype"
                style="width: 92%"
                name="docDesc"
                v-validate="'required'"
              />
              <button
                @click="parseDesc"
                class="searchBtn btn btn-primary btn-sm m-1"
                style="font-size: 16px"
              >
                Parse
              </button>
            </td>
          </tr>
          <tr>
            <th>{{ $t("product.language") }}</th>
            <td>
              <select
                v-model="form.lang"
                class="int_type01 mgt_seltype"
                name="lang"
                v-validate="'required'"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option
                  v-for="(lang, index) in langList"
                  :key="index"
                  :value="lang.codeId"
                >
                  {{ lang.codeName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th>{{ $t("product.documentType") }}</th>
            <td>
              <ul class="group_sel_ul">
                <li>
                  <em>{{ $t("management.mainCategory") }}</em>
                  <select
                    v-model="form.doctypeId"
                    class="int_type01 mgt_seltype"
                    name="doctypeId"
                    v-validate="'required'"
                  >
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(doc, index) in docTypeList"
                      :key="index"
                      :value="doc.doctypeId"
                    >
                      {{ doc.doctypeName }}
                    </option>
                  </select>
                </li>
                <li>
                  <em>{{ $t("product.prodCode") }}</em>
                  <select
                    v-model="form.modelcodeId"
                    class="int_type01 mgt_seltype"
                    name="modelcodeId"
                    v-validate="'required'"
                  >
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(mc, index) in modelcodeList"
                      :key="index"
                      :value="mc.modelcodeId"
                    >
                      {{ mc.modelcodeName }}
                    </option>
                  </select>
                </li>
                <li>
                  <em>{{ $t("management.exhaustCertification") }}</em>
                  <select
                    v-model="form.exhaustCertiId"
                    class="int_type01 mgt_seltype"
                    name="exhaustCertiId"
                    v-validate="'required'"
                  >
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(ex, index) in ecList"
                      :key="index"
                      :value="ex.exhaustCertiId"
                    >
                      {{ ex.exhaustCertiName }}
                    </option>
                  </select>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.productType") }}</th>
            <td>
              <ul class="group_sel_ul">
                <li>
                  <em>{{ $t("management.mainCategory") }}</em>
                  <select
                    v-model="form.upperProdId"
                    class="int_type01 mgt_seltype"
                    @change="getSubProducts(form.upperProdId)"
                    name="upperProdId"
                    v-validate="'required'"
                  >
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(prod, index) in mainProd"
                      :key="index"
                      :value="prod.prodId"
                    >
                      {{ prod.prodName }}
                    </option>
                  </select>
                </li>
                <li>
                  <em>{{ $t("management.subCategory") }}</em>
                  <select v-model="form.prodId" class="int_type01 mgt_seltype">
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(subProd, index) in subProductType"
                      :key="index"
                      :value="subProd.prodId"
                    >
                      {{ subProd.prodName }}
                    </option>
                  </select>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>{{ $t("product.useYN") }}</th>
            <td>
              <input type="radio" v-model="form.useYn" name="useYn" value="Y" /> Y
              <input
                type="radio"
                v-model="form.useYn"
                name="useYn"
                value="N"
                style="margin-left: 10px"
              />
              N
            </td>
          </tr>
          <tr>
            <th>{{ $t("product.model") }}</th>
            <td>
              <div class="d-flex">
                <div class="w-25">
                  <autocomplete
                    :source="modelList"
                    input-class="autocomplete-input mgt_seltype"
                    ref="autocomplete"
                    @selected="validateSelection"
                    @results="getInputValue"
                    placeholder="Search a Model"
                    @clear="clearModel"
                  >
                  </autocomplete>
                </div>
                <div>
                  <button
                    type="button"
                    class="tbl_add_bt"
                    style="height: 36px; width: 36px"
                    @click="addModel"
                  >
                    Add
                  </button>
                </div>
                <div style="margin-left: 10px; margin-top: 5px">
                  <span>Selected Value : </span>
                </div>
                <div style="margin-left: 10px; margin-top: 5px">
                  <span
                    v-for="(item, index) in form.modelNameList"
                    v-bind:key="item"
                    @click="deleteModel(index)"
                    style="margin-right: 10px; cursor: pointer"
                    title="Click to delete"
                    >{{ item }}</span
                  >
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mgt_option_bottom2">
        <button @click="deleteDocument" class="btn btn-secondary m-2">
          {{ $t("common.delete") }}
        </button>
        <button @click="docUpdate()" class="btn btn-primary">
          {{ $t("common.save") }}
        </button>
        <router-link
          :to="{ name: 'mgmtDocument', params: { searchForm : this.$route.params.searchForm } }"
          class="btn btn-outline-dark"
          style="margin-left: 10px"
          >{{ $t("common.list") }}</router-link
        >
      </div>
    </div>

    <div class="management_top_box">
      <h4>{{ $t("management.docVersion") }}</h4>
    </div>
    <div class="brick_box">
      <div class="bt_sm_box" style="display: flex; justify-content: space-between; align-items: center;">
        <p style="font-size: 15px; color: #888; margin: 0;">{{ $t("management.lastVerNotice") }}</p>
        <button @click="showModal" class="btn btn-primary btn_sm">Add Version</button>
      </div>
      <table class="list_tbl">
        <thead>
          <tr>
            <th class="mobile_row">{{ $t("product.pubType") }}</th>
            <th class="mobile_h">{{ $t("common.version") }}</th>
            <th class="mobile_h">{{ $t("product.file") }}</th>
            <th class="mobile_h">{{ $t("product.distribute") }}</th>
            <th class="mobile_h">{{ $t("product.date") }}</th>
            <th class="mobile_h">{{ $t("product.last") }}</th>
            <th class="mobile_h">{{ $t("product.productNumber") }}</th>
            <th class="mobile_h">{{ $t("product.regDate") }}</th>
            <th class="mobile_h" style="width: 80px"></th>
            <th class="mobile_h" style="width: 80px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in versionList" :key="index">
            <td>{{ (item.publishedType == 'PDFPublish' ? 'PDF Publish' : item.publishedType )}}</td>
            <td>{{ item.versMajor }}.{{ item.versMinor }}</td>
            <td>
              <a
                v-if="item.parseStatus == 'COMPLETE' && item.verNodeRef"
                :href="
                  '/docview/model/lang/' +
                  item.verNodeRef.replace('workspace://SpacesStore/', '') +
                  '/index.html'
                "
                target="_blank"
                class="webhelp_icon"
                title="Web View"
                >WebHelp</a
              >
              <!--------------New Webhelp Publishing ------------------------>
              <!-- <a
                v-if="item.parseStatus == 'COMPLETE_NEW' && item.verNodeRef"
                :href="
                  '/docview/model/lang/' +
                  item.verNodeRef.replace('workspace://SpacesStore/', '') +
                  '/index.html'
                "
                target="_blank"
                class="webhelp_icon"
                title="Web View"
                >WebHelp</a
              > -->
              <!-- <a v-else class="webhelp_icon disabled_type text_cursor" title="Web View">WebHelp</a> -->
              <!-- <a :href="'/document/preview?uid=' + item.fileNodeRef.replace('workspace://SpacesStore/','')" target="_blank" class="p_l_icon04" title="PDF View">View</a> -->
              <a
                v-if="item.fileNodeRef"
                @click="pdfDownload(item.fileNodeRef)"
                class="pdf_icon"
                title="PDF Download"
                >PDF</a
              >
              <!-- <a v-else class="pdf_icon disabled_type text_cursor" title="PDF Download">PDF</a> -->
            </td>
            <td>
              <!--배포상태-->
              <select class="int_type01 mgt_seltype" v-model="item.docverStatus" @change="onDistributeChange(index)">
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="P">{{ $t("product.distribute") }}</option>
                <option value="R">{{ $t("product.unDistribute") }}</option>
              </select>
            </td>
            <td>{{ item.publishedDate | moment("YYYY-MM-DD") }}</td>
            <td><input type="checkbox" v-model="item.maxVers" :disabled="item.docverStatus !== 'P'" @change="onLastVerChange(index)" /></td>
            <!--품번 -->
            <td v-if="item.publishedType == 'PDF' || item.publishedType == 'PDFPublish'">
              <input type="text" class="int_type02" v-model="item.partNo" />
            </td>
            <td v-else>
              <input type="text" class="int_type02" v-model="item.partNo" disabled />
            </td>
            <td>{{ item.firstRegDatetime | moment("YYYY-MM-DD") }}</td>
            <td>
              <button class="btn btn-inner" @click="versionUpdate(index)">
                {{ $t("common.save") }}
              </button>
            </td>
            <td>
              <button class="btn btn-inner" @click="versionDelete(index, item.docverId)">
                {{ $t("common.delete") }}
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-if="!hasVersionList">
          <tr>
            <td colspan="9">{{ $t("common.noData") }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <CommonModal
      id="verModal"
      v-if="showVerModal"
      @close="showVerModal == false"
      modalWidth="700px"
    >
      <template slot="header">
        <h3>{{ $t("management.titleAddVersion") }}</h3>
      </template>
      <template slot="body">
        <div style="height: 280px">
          <form id="versionForm" name="versionForm">
            <table class="mgt_tbl mgb_0">
              <colgroup>
                <col style="width: 25%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>Pub. Type</th>
                  <td>
                    <ul class="group_sel_ul">
                      <li>
                        <input
                          type="radio"
                          name="pubType"
                          value="WebHelp"
                          v-model="verPubType"
                          @change="initVariable()"
                        />
                        <label>WebHelp</label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          name="pubType"
                          value="PDFPublish"
                          v-model="verPubType"
                          @change="initVariable()"
                        />
                        <label>PDF Publish</label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          name="pubType"
                          value="PDF"
                          v-model="verPubType"
                          @change="initVariable()"
                        />
                        <label>PDF</label>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>Ver. No</th>
                  <td><input type="number" name="verNo" id="verNo" v-model="verNo" /></td>
                </tr>
                <tr>
                  <th>Repository</th>
                  <td>
                    <select
                      name="verRepository"
                      v-model="verRepository"
                      @change="fetchDoctype"
                      style="min-width: 200px; max-width: 500px"
                    >
                      <option value="">Select...</option>
                      <option
                        v-for="site of verSiteList"
                        v-bind:key="site.shortName"
                        v-bind:value="site.shortName"
                      >
                        {{ site.title }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr v-if="verPubType == 'WebHelp' || verPubType == 'PDFPublish'">
                  <th>Doc. Type</th>
                  <td>
                    <select
                      name="verDoctype"
                      v-model="verDoctype"
                      @change="fetchMaplist"
                      style="min-width: 200px; max-width: 500px"
                    >
                      <option value="">Select...</option>
                      <option
                        v-for="dtype of verDoctypelist"
                        v-bind:key="dtype.name"
                        v-bind:value="dtype.name"
                      >
                        {{ dtype.name }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr v-if="verPubType == 'PDF'">
                  <th>Doc. Type</th>
                  <td>
                    <select
                      name="verDoctype"
                      v-model="verDoctype"
                      @change="fetchPublicationlist"
                      style="min-width: 200px; max-width: 500px"
                    >
                      <option value="">Select...</option>
                      <option
                        v-for="dtype of verDoctypelist"
                        v-bind:key="dtype.name"
                        v-bind:value="dtype.name"
                      >
                        {{ dtype.name }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr v-if="verPubType == 'WebHelp' || verPubType == 'PDFPublish'">
                  <th>DitaMap</th>
                  <td>
                    <select
                      name="verDitamap"
                      v-model="verDitamap"
                      @change="fetchVersionlist"
                      style="min-width: 400px; max-width: 450px"
                    >
                      <option value="">Select...</option>
                      <option
                        v-for="map of verDitamaplist"
                        v-bind:key="map.nodeRef"
                        v-bind:value="map.nodeRef"
                      >
                        {{ map.name }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr v-if="verPubType == 'PDF'">
                  <th>PDF</th>
                  <td>
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm"
                      @click="showPdfModal"
                    >
                      click
                    </button>
                    <span>
                      {{ pdfName == "" ? "" : pdfName }}
                    </span>
                    <!-- <select
                      name="verPublication"
                      v-model="verPublication"
                      @change="fetchVersionlist"
                      style="min-width: 400px; max-width: 450px"
                    >
                      <option value="">Select...</option>
                      <option
                        v-for="map of verPublicationlist"
                        v-bind:key="map.nodeRef"
                        v-bind:value="map.nodeRef"
                      >
                        {{ map.name }}
                      </option>
                    </select> -->
                  </td>
                </tr>

                <tr>
                  <th>Version</th>
                  <td>
                    <select
                      name="ecmVersion"
                      v-model="ecmVersion"
                      @change="getComment"
                      style="min-width: 400px; max-width: 450px"
                    >
                      <option value="">Select...</option>
                      <option
                        v-for="map of ecmVersionlist"
                        v-bind:key="map.nodeRef"
                        v-bind:value="map.nodeRef"
                      >
                        {{ map.version }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>Comment</th>
                  <td>{{ comment }}</td>
                </tr>

                <!-- PDF File Upload -->
                <!--
                        <tr v-if="verPubType != 'WebHelp'">
                            <th>{{$t('common.file')}}</th>
                            <td>
                                <input type="file" name="uploadFile" id="uploadFile" ref="verUploadFile">
                            </td>
                        </tr>
                        <tr v-if="verPubType == 'PDF'">
                            <th>{{$t('product.productNumber')}}</th>
                            <td>
                                <input type="text" name="productNo" id="prodctNo" size="30" maxlength="30" v-model="verPartNo">
                            </td>
                        </tr> -->
              </tbody>
            </table>
          </form>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="saveVersion" class="btn btn-primary">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
    <!---------------------------------PDF Modal------------------------------------------->
    <PDFModal
      id="pdfModal"
      v-if="pdfModal"
      @close="showModal == false"
      modalWidth="700px"
      modalHeight="400px;"
    >
      <template slot="header">
        <h3>{{ $t("management.pdf") }}</h3>
      </template>
      <template slot="body">
        <div class="bg-white p-3 m-3" style="overflow: auto; height: 300px">
          <div class="bg-white p-3 m-3">
            <a-directory-tree
              :replaceFields="replaceFields"
              :treeData="treeData"
              :load-data="loadPdfChildren"
              @select="getChildPdf"
            >
              <a-tree-node key="0-0" title="parent 0">
                <a-tree-node key="0-0-0" title="leaf 0-0" is-leaf />
                <a-tree-node key="0-0-1" title="leaf 0-1" is-leaf />
              </a-tree-node>
              <a-tree-node key="0-1" title="parent 1">
                <a-tree-node key="0-1-0" title="leaf 1-0" is-leaf />
                <a-tree-node key="0-1-1" title="leaf 1-1" is-leaf />
              </a-tree-node>
            </a-directory-tree>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getSelected" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closePdfModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </PDFModal>
    <!---------------------------Webhelp Publishing Status Modal ------------------------------>
    <AlertModal
      id="webhelpAlertModal"
      v-if="webhelpAlertModal"
      @close="webhelpAlertModal == false"
    >
      <template slot="header">
        <h3>Publishing Webhelp</h3>
      </template>
      <template slot="body">
        <div><p>{{ webhelpMessage }}</p></div>
        <div>{{webhelpStatus}}</div>
        <div  v-if="webhelpJsonError &&  webhelpJsonError!=''"  class="json-box" style="overflow: auto; height: 250px">
          <pre>
            <code>
              {{webhelpJsonError}}
            </code>
          </pre>
        </div>
      </template>
      <template slot="footer">
        <button
          type="button"
          @click="closeWebhelpAlert"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </AlertModal>
    <!---------------------------PDF Publishing Status Modal ------------------------------>
    <AlertModal
      id="pdfAlertModal"
      v-if="pdfAlertModal"
      @close="pdfAlertModal == false"
    >
      <template slot="header">
        <h3>Publishing PDF</h3>
      </template>
      <template slot="body">
        <div><p>{{ pdfMessage }}</p></div>
        <div>{{pdfStatus}}</div>
        <div v-if="pdfJsonError &&  pdfJsonError!=''" class="json-box" style="overflow: auto; height: 250px">
          <pre>
            <code>
              {{pdfJsonError}}
            </code>
          </pre>
        </div>
      </template>
      <template slot="footer">
        <button
          type="button"
          @click="closePdfAlert"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </AlertModal>
  </section>
</template>

<script>
import $ from "jquery";
import {
  docdetailsList,
  documentUpdate,
  docverUpdate,
  docverDelete,
  documentDelete,
  getSiteList,
  getDoctypes,
  getMaplist,
  getPublicationlist,
  createWebhelpVer,
  createFileVer,
  versionList,
  preDownload,
  getVersionlist,
  checkBookmarkAndFeedbackExist,
  getChildPublicationlist,
  getDataParser,
  createPDFVer,
  getWebhelpPublishStatus,
  checkWebhelpPublishExist,
  checkPDFPublishExist,
  getPDFPublishStatus,
  updateMaxVersYN
} from "@/api/document";
import CommonModal from "@/components/modal/CommonModal";
import PDFModal from "@/components/modal/PDFModal";
import AlertModal from "@/components/modal/AlertModal";
import Autocomplete from "vuejs-auto-complete";
// import { VueTreeList, Tree, TreeNode } from "vue-tree-list";
export default {
  components: {
    CommonModal,
    Autocomplete,
    PDFModal,
    AlertModal
    // VueTreeList,
  },
  data() {
    return {
      versionList: [],
      originalVersionList: [],
      docTypeList: [],
      mainProd: [],
      modelList: [],
      subProd: [],
      langList: [],
      ecList: [],
      subProductType: "",
      modelcodeList: [],
      hasVersionList: true,
      form: {
        docId: "",
        docverId: "",
        docTitle: "",
        docDesc: "",
        doctypeId: "",
        modelcodeId: "",
        modelNameList: [],
        exhaustCertiId: "",
        prodId: "",
        upperProdId: "",
        lang: "",
      },
      confirmYN: false,
      verNo: "1.0",
      verPubType: "WebHelp",
      verPartNo: "",
      verSiteList: [],
      verRepository: "",
      verDoctypelist: [],
      verDoctype: "",
      verDitamaplist: [],
      verDitamap: "",
      verPublicationlist: [],
      verPublication: "",
      isLoading: false,
      tmpValue: "",
      showVerModal: false,
      pdfModal: false,
      ecmVersionlist: [],
      ecmVersion: "",
      comment: "",
      bookmarkData: [],
      feedbackData: [],
      modelName: "",
      allPdfList: [],
      pdfList: [],
      // folderPdfList: [],
      treeData: [],
      replaceFields: {
        title: "name",
        key: "id",
        Pid: "pid",
      },
      checkedKeys: [],
      pdfName: "",
      childPdfList: [],
      childFolderPdfList: [],
      showLine: true,
      showIcon: false,
      addData: [],
      selectedPDF: "",
      splitedModelName: [],
      webhelpMessage : "",
      pdfMessage : "",
      // 발행 상태 폴링 연속 실패 허용 횟수 (5초 간격 x 5회 = 약 25초)
      POLL_MAX_FAIL : 5,
      webPollFailCount : 0,
      pdfPollFailCount : 0,
      webhelpAlertModal : false,
      pdfAlertModal : false,
      mapRef: "",
      webhelpStatus :"",
      pdfStatus : "",
      webhelpJsonError : "",
      pdfJsonError : ""
    };
  },
  mounted() {
    this.fetchData();
  },
  beforeDestroy() {
    // 발행 폴링 중 화면을 벗어나면 타이머를 정리한다.
    // 완료 시 표시할 모달과 목록 갱신 대상이 이미 사라진 상태라 계속 폴링해도 얻는 것이 없다.
    if (this.webInterval) {
      clearInterval(this.webInterval);
      this.webInterval = null;
    }
    if (this.pdfInterval) {
      clearInterval(this.pdfInterval);
      this.pdfInterval = null;
    }
  },
  methods: {
    // Model 입력할때마다 값 저장
    getInputValue() {
      this.tmpValue = $(".autocomplete-input").val();
      // 양쪽 공백 제거
      this.tmpValue = this.tmpValue.trim();
    },
    closeWebhelpAlert(){
      this.webhelpAlertModal = false;
    },
    closePdfAlert(){
      this.pdfAlertModal = false;
    },
    // 새로운 Model 추가
    addModel() {
      // 빈값과 기존에 있는 값 검사
      for (let j in this.modelList) {
        if (this.modelList[j].name == this.tmpValue || this.tmpValue == "") {
          alert(this.$t("alert.pleaseCheckTheValue"));
          return;
        }
      }
      this.modelList.push({ id: this.modelList.length + 1, name: this.tmpValue });
      this.validateSelection({ display: this.tmpValue });
    },
    validateSelection(selection) {
      if (
        selection.display != null && this.form.modelNameList && this.form.modelNameList.length > 0 && 
        !this.form.modelNameList.includes(selection.display)
      ) {
        this.form.modelNameList.push(selection.display);
      }
      if(!this.form.modelNameList || this.form.modelNameList.length == 0){
        console.log(this.form.modelNameList);
        this.form.modelNameList = [];
        this.form.modelNameList.push(selection.display);
      }
    },
    clearModel() {
      // 클리어 시 기존 ModelName 복구
      // this.form.modelName = this.modelName;
    },
    // 분류조회
    async fetchData() {
      try {
        this.form.docId = this.$route.params.docId;

        const resp = await docdetailsList(this.form);

        this.docTypeList = resp.data.docTypeList;
        this.mainProd = resp.data.mainProd;
        this.subProd = resp.data.subProd;
        this.langList = resp.data.langList;
        this.ecList = resp.data.ecList;
        this.modelcodeList = resp.data.modelcodeList;
        this.modelList = resp.data.modelList;
        this.setForm(resp.data.docVO);
        this.versionList = resp.data.versionList;
        this.originalVersionList = JSON.parse(JSON.stringify(this.versionList));
        this.hasVersionList = this.versionList.length > 0;

        if (this.hasVersionList) {
          const ver = this.versionList[0];
          this.verNo = ver.versMajor + "." + (parseInt(ver.versMinor) + 1);
        }

        // this.checkBookmarkAndFeedbackExist();
      } catch (err) {
        console.log(err);
      }
    },
    async refreshVersionList() {
      const param = { docId: this.form.docId };

      const resp = await versionList(param);
      this.versionList = resp.data.versionList;
      this.originalVersionList = JSON.parse(JSON.stringify(this.versionList));
      this.hasVersionList = this.versionList.length > 0;

      if (this.hasVersionList) {
        const ver = this.versionList[0];
        this.verNo = ver.versMajor + "." + (parseInt(ver.versMinor) + 1);
      }
    },
    // 대분류 선택시 중분류
    getSubProducts(prodId) {
      this.form.prodId = "";
      this.subProductType = [];
      for (let i in this.subProd) {
        if (prodId === this.subProd[i].upperProdId) {
          this.subProductType.push(this.subProd[i]);
        }
      }
    },
    async docUpdate() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        this.confirmYN = confirm(this.$t("alert.save"));
        if (this.confirmYN) {
          const resp = await documentUpdate(this.form);
          if (resp.data.status) {
            alert(this.$t("alert.savedSuccessfully"));
          } else {
            if (resp.data.reason == "TITLE") {
              alert(this.$t("alert.duplicateDocTitle"));
            } else {
              alert(this.$t("alert.ErrorPlzcontactManager"));
            }
          }
        } else {
          return;
        }
      } catch (err) {
        console.log(err);
      }
    },
    setForm(docVO) {
      this.form.docTitle = docVO.docTitle;
      this.form.docDesc = docVO.docDesc;
      this.form.doctypeId = docVO.doctypeId;
      this.form.modelcodeId = docVO.modelcodeId;
      this.form.exhaustCertiId = docVO.exhaustCertiId;
      this.form.lang = docVO.lang;
      this.form.useYn = docVO.useYn;

      this.form.upperProdId = docVO.upperProdId;
      this.getSubProducts(docVO.upperProdId);
      this.form.prodId = docVO.prodId != null ? docVO.prodId : "";

      this.form.modelName = docVO.modelName;
      this.form.modelNameList = docVO.modelNameList;
    },
    onDistributeChange(index) {
      var item = this.versionList[index];
      if (item.docverStatus === 'P') {
        item.maxVers = true;
        // 같은 타입의 다른 버전 Last Ver 해제
        var typeGroup = this.getTypeGroup(item.publishedType);
        for (var i = 0; i < this.versionList.length; i++) {
          if (i !== index && this.getTypeGroup(this.versionList[i].publishedType) === typeGroup) {
            this.versionList[i].maxVers = false;
          }
        }
      } else {
        item.maxVers = false;
      }
    },
    onLastVerChange(index) {
      var item = this.versionList[index];
      if (item.maxVers) {
        // 같은 타입의 다른 버전 Last Ver 해제 (하나만 허용)
        var typeGroup = this.getTypeGroup(item.publishedType);
        for (var i = 0; i < this.versionList.length; i++) {
          if (i !== index && this.getTypeGroup(this.versionList[i].publishedType) === typeGroup) {
            this.versionList[i].maxVers = false;
          }
        }
      }
    },
    getTypeGroup(publishedType) {
      return publishedType === 'WebHelp' ? 'WebHelp' : 'PDF';
    },
    async versionUpdate(index) {
      try {
        var thisVer = this.versionList[index];
        var typeGroup = this.getTypeGroup(thisVer.publishedType);

        // 저장 후 상태 시뮬레이션: 현재 버전은 UI 값, 나머지는 원본(DB) 값 사용
        var afterSaveHasDistributed = false;
        var afterSaveHasLastVer = false;

        for (var k = 0; k < this.originalVersionList.length; k++) {
          var ov = this.originalVersionList[k];
          if (this.getTypeGroup(ov.publishedType) !== typeGroup) continue;

          if (ov.docverId === thisVer.docverId) {
            // 현재 저장하려는 버전: UI 값 사용
            if (thisVer.docverStatus === 'P') afterSaveHasDistributed = true;
            if (thisVer.docverStatus === 'P' && thisVer.maxVers) afterSaveHasLastVer = true;
          } else {
            // 다른 버전: DB 원본 값 사용
            if (ov.docverStatus === 'P') afterSaveHasDistributed = true;
            if (ov.docverStatus === 'P' && ov.maxVers) afterSaveHasLastVer = true;
          }
        }

        // Distributed 버전이 있는데 Last Ver 이 하나도 없으면 저장 불가
        if (afterSaveHasDistributed && !afterSaveHasLastVer) {
          alert(this.$t("alert.mustHaveAtLeastOneLastVer", { typeGroup: typeGroup }));
          return;
        }

        // 원본 데이터에서 같은 타입의 다른 Last Ver 찾기 (DB 기준)
        var originalLastVer = null;
        for (var i = 0; i < this.originalVersionList.length; i++) {
          var origVer = this.originalVersionList[i];
          if (origVer.docverId !== thisVer.docverId &&
              this.getTypeGroup(origVer.publishedType) === typeGroup &&
              origVer.docverStatus === 'P' &&
              origVer.maxVers) {
            originalLastVer = origVer;
            break;
          }
        }

        if (thisVer.maxVers && thisVer.docverStatus === 'P' && originalLastVer) {
          // Last Ver 체크 상태로 저장 + DB에 다른 Last Ver 존재 → 변경 여부 확인
          if (!confirm(this.$t("alert.confirmChangeLastVer"))) {
            return;
          }
          // 기존 Last Ver 해제 (인덱싱 없이 MAXVERS_YN만 변경)
          await updateMaxVersYN({
            docId: originalLastVer.docId,
            docverId: originalLastVer.docverId,
            maxversYn: "N"
          });
        } else {
          if (!confirm(this.$t("alert.save"))) return;
        }

        if (thisVer.maxVers) thisVer.maxversYn = "Y";
        else thisVer.maxversYn = "N";

        const resp = await docverUpdate(thisVer);
        if (resp.data.status) {
          alert(this.$t("alert.savedSuccessfully"));
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }

        this.refreshVersionList();
      } catch (err) {
        console.log(err);
      }
    },
    // 삭제전 feedback/bookmark 여부 확인
    async versionDelete(index, docverId) {
      this.form.docverId = docverId;
      await this.checkBookmarkAndFeedbackExist();
      if (this.bookmarkData.length > 0 || this.feedbackData.length > 0) {
        alert(
          this.$t("alert.ItCantNotBeDeletedThereSomeBookmarkOrFeedbackDataInThisDocument")
        );
        return;
      } else {
        this.verDelete(index);
      }
    },
    async verDelete(index) {
      let loader = this.$loading.show({});

      try {
        this.confirmYN = confirm(this.$t("alert.delete"));
        if (this.confirmYN) {
          const resp = await docverDelete(this.versionList[index]);

          if (!resp.data.status) {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        }
        this.refreshVersionList();
      } catch (err) {
        console.log(err);
      } finally {
        loader.hide();
      }
    },
    async docDelete() {
      let loader = this.$loading.show({});

      try {
        this.confirmYN = confirm(this.$t("alert.delete"));
        if (this.confirmYN) {
          const resp = await documentDelete(this.form);
          if (resp.data.status) {
            alert(this.$t("alert.deleteSuccessfully"));
            this.$router.push("/management/library/document");
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        }

        this.fetchData();
      } catch (err) {
        console.log(err);
      } finally {
        loader.hide();
      }
    },
    showModal() {
      this.verRepository = "";

      this.verDoctypelist = [];
      this.verDoctype = "";

      this.verDitamap = "";
      this.verDitamaplist = [];
      this.showVerModal = true;
    },
    closeModal() {
      this.showVerModal = false;
    },
   
    getMapName(mapRef) {
      for (var i = 0; this.verDitamaplist.length; i++) {
        if (this.verDitamaplist[i].nodeRef == mapRef) {
          return this.verDitamaplist[i].name;
        }
      }
      return "";
    },
    getPdfName(pdfRef) {
      for (var i = 0; this.verPublicationlist.length; i++) {
        if (this.verPublicationlist[i].nodeRef == pdfRef) {
          return this.verPublicationlist[i].name;
        }
      }
      return "";
    },
    // PDF version update 구 버전
    async savePDF(langfull, loader) {
      try {
        const pdfName = this.pdfName;
        //this.getPdfName(this.verPublication);

        const formData = new FormData();
        formData.append("pubType", this.verPubType);
        formData.append("langFull", langfull);
        formData.append("lang", this.form.lang);
        formData.append("docId", this.form.docId);
        formData.append("verNo", this.verNo);
        formData.append("partNo", this.verPartNo);

        formData.append("pdfName", pdfName);
        formData.append("pdfRef", this.verPublication);
        //            formData.append('pdfFile',this.$refs.verUploadFile.files[0]);

        const resp = await createFileVer(formData);

        if (!resp.data.status) {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }

      this.refreshVersionList();
      this.closeModal();

      loader.hide();
    },
    async fetchEcmRepository() {
      try {
        this.verDoctype = "";
        this.verDoctypelist = [];
        this.verDitamap = "";
        this.verDitamaplist = [];

        const response = await getSiteList();
        this.verSiteList = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchDoctype() {
      try {
        this.verDoctypelist = [];
        this.verDoctype = "";

        this.verDitamap = "";
        this.verDitamaplist = [];

        if(this.verRepository){
          const param = { site: this.verRepository };
          const response = await getDoctypes(param);
          this.verDoctypelist = response.data;
        }else{
          this.verDoctypelist = [];
        }

      } catch (error) {
        console.log(error);
      }
    },
    async fetchMaplist() {
      if (this.verDoctype == "") return;

      this.verDitamaplist = [];
      this.verDitamap = "";

      try {
        const param = { site: this.verRepository, doctype: this.verDoctype };
        const response = await getMaplist(param);
        this.verDitamaplist = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    showPdfModal() {
      if (this.verDoctype == "") return alert(this.$t("alert.pleaseSelectDocType"));
      this.pdfModal = true;
    },
    closePdfModal() {
      this.pdfModal = false;
    },
    // pdf 가져오기
    async fetchPublicationlist() {
      if (this.verDoctype == "") return;
      this.verPublication = "";
      this.pdfList = [];
      this.selectedPDF = "";
      this.pdfName = "";
      try {
        const param = { site: this.verRepository, doctype: this.verDoctype };
        const { data } = await getPublicationlist(param);
        this.allPdfList = data.allPdfList;
        this.pdfList = data.pdfList;
        for (let i in this.allPdfList) {
          if (this.allPdfList[i].nodeRef == null) {
            this.allPdfList[i].isLeaf = false;
          } else {
            this.allPdfList[i].isLeaf = true;
          }
        }
        this.items = data.allPdfList;
        this.treeData = this.items;
      } catch (error) {
        console.log(error);
      }
    },
    // 선택한 folder 의 파일 여부 확인
    getChildPdf(selectedKeys, e) {
      if (e.node != null && e.node != undefined) {
        if (e.node._props != null && e.node._props != undefined) {
          this.selectedPDF = e.node._props.dataRef;
          this.checkedKeys = [];
          // if (selectedKeys[selectedKeys.length - 1] == this.selectedPDF.id) {
          // noderef 가 null 일때 ==  폴더
          if (this.selectedPDF.nodeRef == null && this.selectedPDF.children == null) {
            // 폴더 하위 목록은 펼칠 때 loadPdfChildren 에서 가져온다
            return;
          } else {
            this.checkedKeys = this.selectedPDF.id;
          }
        }
      }
      // }
    },
    // 폴더를 펼칠 때(화살표, 폴더명 클릭) 하위 목록 가져오기
    loadPdfChildren(treeNode) {
      const folder = treeNode.dataRef;
      if (folder.nodeRef != null || folder.children != null) return Promise.resolve();
      return this.getChildPdfList(folder);
    },
    // pdf child 가져오기
    async getChildPdfList(pdfVO) {
      try {
        pdfVO.site = this.verRepository;
        pdfVO.doctype = this.verDoctype;
        let loader = this.$loading.show({});
        const { data } = await getChildPublicationlist(pdfVO);
        loader.hide();
        this.childPdfList = data.childPdfList;
        if (this.childPdfList.length > 0) {
          let pid = "";
          for (let j in this.childPdfList) {
            pid = this.childPdfList[j].pid;
            // 폴더 여부 확인
            if (this.childPdfList[j].nodeRef == null) {
              this.childPdfList[j].isLeaf = false;
            } else {
              this.childPdfList[j].isLeaf = true;
            }
          }
          this.addData = this.makeChildPdf(this.items, this.childPdfList, pid);
          if (this.addData != null) {
            this.treeData = [];
            this.treeData = this.addData;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    makeChildPdf(currentItem, childPdfList, pid) {
      for (let i in currentItem) {
        let item = currentItem[i];
        if (item.id == pid) {
          item.children = childPdfList;
          return currentItem;
        } else {
          this.makeChildPdf(item.children, childPdfList, pid);
        }
      }
    },
    // 선택한 PDF 선택
    getSelected() {
      if (this.selectedPDF != "" && this.selectedPDF.nodeRef == null) {
        alert(this.$t("alert.youCanNotAddFolder"));
        this.checkedKeys = [];
        return;
      }
      this.pdfName = this.selectedPDF.name;
      this.verPublication = this.selectedPDF.nodeRef;
      this.pdfModal = false;
      // pdf 선택후 Version get
      this.fetchVersionlist();
    },
    async pdfDownload(uid) {
      if (uid != null) {
        uid = uid.replace("workspace://SpacesStore/", "");
      }
      console.log(uid);
      let loader = this.$loading.show({});

      const response = await preDownload(uid);
      if (response.data.status) {
        loader.hide();
        window.open("/document/download/pdf?uid=" + uid);
      } else {
        loader.hide();
        alert("Download failed");
      }
    },
    async fetchVersionlist() {
      if (this.verDoctype == "") return;

      if (
        (this.verPubType == "WebHelp" && this.verDitamap == "") || (this.verPubType == "PDFPublish" && this.verDitamap == "") || 
        (this.verPubType == "PDF" && this.verPublication == "")
      ) {
        return;
      }
      var nodeRef = "";
      if (this.verPubType == "WebHelp" || this.verPubType == "PDFPublish") {
        nodeRef = this.verDitamap;
      } else {
        nodeRef = this.verPublication;
      }

      this.ecmVersionlist = [];
      this.ecmVersion = "";

      try {
        const param = { nodeRef: nodeRef };
        const response = await getVersionlist(param);
        this.ecmVersionlist = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    getComment() {
      this.comment = "";
      for (var i = 0; i < this.ecmVersionlist.length; i++) {
        if (this.ecmVersionlist[i].nodeRef != "") {
          if (this.ecmVersionlist[i].nodeRef == this.ecmVersion) {
            this.comment = this.ecmVersionlist[i].comment;
            this.verNo = this.ecmVersionlist[i].version;
          }
        }
      }
    },
    async deleteDocument() {
      await this.checkBookmarkAndFeedbackExist();
      if (this.versionList.length > 0) {
        alert(this.$t("alert.ItCantNotBeDeletedThereSomeVersionInThisDocument"));
        return;
      }
      if (this.bookmarkData.length > 0 || this.feedbackData.length > 0) {
        alert(
          this.$t("alert.ItCantNotBeDeletedThereSomeBookmarkOrFeedbackDataInThisDocument")
        );
        return;
      } else {
        this.docDelete();
      }
    },
    async checkBookmarkAndFeedbackExist() {
      this.bookmarkData = [];
      this.feedbackData = [];
      const { data } = await checkBookmarkAndFeedbackExist(this.form);
      this.bookmarkData = data.bookmarkData;
      this.feedbackData = data.feedbackData;
    },
    initVariable() {
      this.verRepository = "";
      this.verDoctype = "";
      this.verDitamap = "";
      this.ecmVersion = "";
      this.Comment = "";
      this.verPublication = "";
    },
    deleteModel(index) {
      this.form.modelNameList.splice(index, 1);
    },
    async parseDesc() {
      const response = await getDataParser(this.form);
      if (response.data.status) {
        this.form.doctypeId = response.data.doctypeId;
        this.form.modelcodeId = response.data.modelcodeId;
        this.form.modelNameList = response.data.modelNameList;
        this.form.exhaustCertiId = response.data.exhaustCertiId;
        this.form.lang = response.data.lang;
        this.form.upperProdId = response.data.prodId;
        this.getSubProducts(this.form.upperProdId);
        this.form.prodId = "";
        //        alert("Parsing the description was successful.");
      } else {
        alert("Failed to parse the description.");
      }
    },
    // Webhelp , PDF Publising 및 Version Update
    saveVersion(e) {
      let loader = this.$loading.show({});

      var lang = "English";
      for (var i = 0; this.langList.length; i++) {
        if (!this.langList[i]) continue;
        if (this.langList[i].codeId == this.form.lang) {
          lang = this.langList[i].codeName;
          break;
        }
      }

      if (this.verPubType == "WebHelp") this.checkWebhelpPublishExist(lang, loader, e);
      else if(this.verPubType == "PDFPublish") this.checkPDFPublishExist(lang, loader, e);
      else this.savePDF(lang, loader, e);
    },
    // Webhelp Publising 중인 상태가 있는지 확인
    async checkWebhelpPublishExist(langfull,loader){
      let mapRef = this.verDitamap;
      if(this.ecmVersion != null && this.ecmVersion != '')
        mapRef = this.ecmVersion;
      if (mapRef != null) {
        mapRef = mapRef.replace("versionStore://version2Store/", "");
      }
      const resp = await checkWebhelpPublishExist(mapRef);
      console.log("check exist");
      console.log(resp);
      // 생성중이 아닐경우
      if (!resp.data.status) {
        this.saveWebHelp(langfull, loader);
      }else if(resp.data.status == "started" || resp.data.status == "running"){
        this.closeModal();
        loader.hide();
        this.webhelpMessage = "On Processing";
        if(resp.data.started){
          this.webhelpStatus = "Started : "+resp.data.started;
        }
        this.webhelpAlertModal = true;
      }else if(resp.data.status == "failed"){
        this.closeModal();
        loader.hide();
        this.webhelpMessage = "Fail to Publish";
        this.webhelpAlertModal = true;
      }

    },
    async saveWebHelp(langfull, loader) {
      const mapName = this.getMapName(this.verDitamap);
      
      let mapRef = this.verDitamap;
      if(this.ecmVersion != null && this.ecmVersion != '')
         mapRef = this.ecmVersion;
         
      const param = {
        pubType: this.verPubType,
        mapName: mapName,
        mapRef: mapRef,
        langFull: langfull,
        lang: this.form.lang,
        docId: this.form.docId,
        verNo: this.verNo,
      };
      const resp = await createWebhelpVer(param);
      if (resp.data.status=="failed") {
        if(resp.data.message){
          alert(resp.data.message);
        }else{
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      }
      // this.refreshVersionList();
      this.closeModal();
      loader.hide();

      if(resp.data.status!="failed"){
        this.webhelpJsonError = "";
        this.webhelpMessage = "On Processing";
        if(resp.data.started){
          this.webhelpStatus = "Started : "+resp.data.started;
        }else{
          let today = new Date(+new Date() + 3240 * 10000).toISOString().replace("T"," ").replace(/\..*/,'');
          this.webhelpStatus = "Started : "+today;
        }
       
        this.webhelpAlertModal = true;
        this.mapRef = mapRef;
        // 이전 폴링이 남아 있으면 핸들이 덮어써져 영원히 멈출 수 없게 되므로 먼저 정리한다
        if (this.webInterval) clearInterval(this.webInterval);
        this.webPollFailCount = 0;
        this.webInterval = setInterval(this.getWebhelpPublishStatus,5000);
      }

    },
    // Webhelp Publishing Status 체크
    async getWebhelpPublishStatus(){
      try {
        let mapRef = this.mapRef;
        if (mapRef != null) {
          mapRef = mapRef.replace("versionStore://version2Store/", "");
        }
        const resp = await getWebhelpPublishStatus(mapRef);
        console.log(resp);
        // 응답 인터셉터가 실패를 reject 하지 않아 resp 가 undefined 로 넘어올 수 있다.
        // 응답을 확인한 뒤에 초기화해야 연속 실패 한도가 동작한다.
        if (!resp || !resp.data) throw new Error("empty webhelp publish status response");
        this.webPollFailCount = 0;   // 정상 응답이면 연속 실패 카운트 초기화
        if(!resp.data.status){
          clearInterval(this.webInterval);
          this.refreshVersionList();
        }else if(resp.data.status=="finished"){
          if(resp.data.message){
            this.webhelpMessage = "Succefully published, But it has Error.";
            this.webhelpJsonError = JSON.parse(resp.data.message);
          }else{
            this.webhelpMessage = "Succefully published";
          }
          this.webhelpAlertModal = true;
          clearInterval(this.webInterval);
          this.refreshVersionList();
        }else if(resp.data.status=="failed"){
          if(resp.data.message){
            this.webhelpJsonError = JSON.parse(resp.data.message);
          }
          this.webhelpMessage = "Fail to publish";
          this.webhelpAlertModal = true;
          clearInterval(this.webInterval);
          this.refreshVersionList();
        }

      }catch(err){
        console.log(err);
        // 일시적 오류는 재시도하되, 연속 실패가 이어지면 무한 폴링을 멈춘다.
        // (기존에는 종료 조건에 걸리지 않아 5초마다 영구히 재시도했다)
        this.webPollFailCount = (this.webPollFailCount || 0) + 1;
        if (this.webPollFailCount >= this.POLL_MAX_FAIL) {
          clearInterval(this.webInterval);
          this.webInterval = null;
          this.webhelpMessage = "Fail to check publishing status.";
          this.webhelpAlertModal = true;
        }
      }
    },
    // PDF Publising 중인 상태가 있는지 확인
    async checkPDFPublishExist(langfull,loader){
      let mapRef = this.verDitamap;
      if(this.ecmVersion != null && this.ecmVersion != '')
        mapRef = this.ecmVersion;
      if (mapRef != null) {
        mapRef = mapRef.replace("versionStore://version2Store/", "");
      }
      const resp = await checkPDFPublishExist(mapRef);

      this.closeModal();
      loader.hide();

      // 생성중이 아닐경우
      if (!resp.data.status) {
        this.savePDFPublish(langfull, loader);
      }else if(resp.data.status == "started" || resp.data.status == "running"){
        this.closeModal();
        loader.hide();
        this.pdfMessage = "On Processing";
        if(resp.data.started){
          this.pdfStatus = "Started : "+resp.data.started;
        }
        this.pdfAlertModal = true;
      }else if(resp.data.status == "failed"){
        this.closeModal();
        loader.hide();
        this.pdfMessage = "Fail to Publish";
        this.pdfAlertModal = true;
      }
    },
    // 23.10.27 PDF Publishing 추가
    async savePDFPublish(langfull, loader) {
      let mapRef = this.verDitamap;
      const mapName = this.getMapName(this.verDitamap);
      if(this.ecmVersion != null && this.ecmVersion != '')
        mapRef = this.ecmVersion;
      try {
        // const pdfName = this.pdfName;
        //this.getPdfName(this.verPublication);
        const formData = new FormData();
        formData.append("pubType", this.verPubType);
        formData.append("langFull", langfull);
        formData.append("lang", this.form.lang);
        formData.append("docId", this.form.docId);
        formData.append("verNo", this.verNo);
        formData.append("partNo", this.verPartNo);

        // formData.append("pdfName", pdfName);
        // formData.append("pdfRef", this.verPublication);
        formData.append("mapName", mapName);
        formData.append("mapRef", mapRef);

        //            formData.append('pdfFile',this.$refs.verUploadFile.files[0]);

        const resp = await createPDFVer(formData);
        console.log(resp);
        if (resp.data.status=="failed") {
          if(resp.data.message){
            alert(resp.data.message);
          }else{
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        }

        this.closeModal();
        loader.hide();

        if(resp.data.status!="failed"){
          this.pdfJsonError = "";
          this.pdfMessage = "On Processing";
          if(resp.data.started){
            this.pdfStatus = "Started : "+resp.data.started;
          }else{
            let today = new Date(+new Date() + 3240 * 10000).toISOString().replace("T"," ").replace(/\..*/,'');
            this.pdfStatus = "Started : "+today;
          }
        
          this.pdfAlertModal = true;
          this.mapRef = mapRef;
          // 이전 폴링이 남아 있으면 핸들이 덮어써져 영원히 멈출 수 없게 되므로 먼저 정리한다
          if (this.pdfInterval) clearInterval(this.pdfInterval);
          this.pdfPollFailCount = 0;
          this.pdfInterval = setInterval(this.getPDFPublishStatus,5000);
        }

      } catch (err) {
        this.closeModal();
        loader.hide();
        alert(this.$t("alert.ErrorPlzcontactManager"));
        console.log(err);
      }
    },
    // Webhelp Publishing Status 체크
    async getPDFPublishStatus(){
      try {
        let mapRef = this.mapRef;
        if (mapRef != null) {
          mapRef = mapRef.replace("versionStore://version2Store/", "");
        }
        const resp = await getPDFPublishStatus(mapRef);
        console.log(resp);
        // 응답 인터셉터가 실패를 reject 하지 않아 resp 가 undefined 로 넘어올 수 있다.
        // 응답을 확인한 뒤에 초기화해야 연속 실패 한도가 동작한다.
        if (!resp || !resp.data) throw new Error("empty pdf publish status response");
        this.pdfPollFailCount = 0;   // 정상 응답이면 연속 실패 카운트 초기화
        if(!resp.data.status){
          clearInterval(this.pdfInterval);
          this.refreshVersionList();
        }else if(resp.data.status=="finished"){
          if(resp.data.message){
            this.pdfMessage = "Succefully published, But it has Error.";
            this.pdfJsonError = JSON.parse(resp.data.message);
          }else{
            this.pdfMessage = "Succefully published";
          }
          this.pdfAlertModal = true;
          clearInterval(this.pdfInterval);
          this.refreshVersionList();
        }else if(resp.data.status=="failed"){
          if(resp.data.message){
            this.pdfJsonError = JSON.parse(resp.data.message);
          }
          this.pdfMessage = "Fail to publish";
          this.pdfAlertModal = true;
          clearInterval(this.pdfInterval);
          this.refreshVersionList();
        }
      }catch(err){
        console.log(err);
        // 일시적 오류는 재시도하되, 연속 실패가 이어지면 무한 폴링을 멈춘다.
        // (기존에는 종료 조건에 걸리지 않아 5초마다 영구히 재시도했다)
        this.pdfPollFailCount = (this.pdfPollFailCount || 0) + 1;
        if (this.pdfPollFailCount >= this.POLL_MAX_FAIL) {
          clearInterval(this.pdfInterval);
          this.pdfInterval = null;
          this.pdfMessage = "Fail to check publishing status.";
          this.pdfAlertModal = true;
        }
      }
    },
  },
  created() {
    this.fetchEcmRepository();
  },
};
</script>

<style>
.json-box{
  border: 0.1px solid #6c757d;
}
</style>
